import * as React from 'react'
import '../../../strategic-details-tabs/style.scss'
import Skeleton from 'telstra-ui/components/skeleton/Skeleton'
import {MDUMPageWrapper} from '@applications/mobile-data-usage-meter/components/mdum-page-wrapper/mdum-page-wrapper'
import {NPErrorBoundary} from '@components/error-boundary'
import {CONSTANTS} from '@applications/mobile-data-usage-meter/utils/enum-constants'
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'telstra-ui/components/tab/Tabs'
import {headerName} from '@telstra-connect/mobile-data-usage-meter/helpers/common-static-data'
import {ListItem, ListItemDescription} from 'telstra-ui/components/list/List'
import {useCustomParams} from '@utils/withRouterWrapper'
import {IRouteParams} from '../..'
import {UsageLazyLoadingComponent} from './usage-lazy-loading'

const SkeletonScreen = () => <Skeleton count={1} height="20px" width="140px" />

const renderField = (itemText) => {
  return (
    <ListItem itemText={itemText}>
      <ListItemDescription>
        <SkeletonScreen />
      </ListItemDescription>
    </ListItem>
  )
}

const renderGroupSingleItem = (label) => {
  return (
    <div className="tc-mobility-details-service-status-block hidden-xs">
      <div className="tc-mobility-details-service-status">
        <h4 className="tc-mobility-details-service-status-label">{label}</h4>
        <div className="tc-mobility-details-service-status-value">
          {<SkeletonScreen />}
          {/* {showToolTip()} */}
        </div>
      </div>
    </div>
  )
}

const renderGroupItem = (label) => {
  return (
    <div className="tc-mobility-details-group-block">
      <div className="tc-mobility-details-group-heading">
        <h4 className="tc-mobility-details-group-heading-title">{label}</h4>
      </div>
      <div className="tc-mobility-details-group-item">
        <>
          <div className="tc-mobility-details-group-items-block">
            <div className="tc-mobility-details-item-label">{<SkeletonScreen />}</div>
            <div className="tc-mobility-details-item-value">{<SkeletonScreen />}</div>
          </div>
        </>
      </div>
    </div>
  )
}

export const ServiceDetailsLoadingComponent = () => {
  return (
    <div>
      <h2 className="heading20">{headerName.serviceDetails}</h2>
      {renderField('Service status')}
      {renderField('Billing account')}
      {renderField('Plan name')}
      {renderField('Offer ID')}
      {renderField('Plan type')}
      {renderField('SIM serial')}
      {renderField('Personal Unlocking Key (PUK)')}
      <br />
      <h2 className="heading20">{headerName.agreementDetails}</h2>
      {renderField('Early Termination Charges')}
      {renderField('Agreement End Date')}
      {renderField('Device')}
    </div>
  )
}

export const LazyLoadingNewComponent = () => {
  const {offerId: offerIdParam, billingNumber: billingNumberParam} = useCustomParams<IRouteParams>()
  const activeTab = offerIdParam && billingNumberParam ? CONSTANTS.SERVICE_USAGE : CONSTANTS.SERVICE_CONFIG

  return (
    <NPErrorBoundary>
      <MDUMPageWrapper pageClassName="view-service-details">
        <div className="tc-mobility-service-details">
          <div className="tc-mobility-padding-mb-24 tc-mobility-service-details-lazy-container">
            <div className="able-Spacing able-Spacing--top--spacing3x able-Spacing--bottom--spacing3x">
              <SkeletonScreen />
            </div>
            <div className="">
              <h1 className="able-text-style able-text-style--HeadingA able-Spacing able-Spacing--bottom--spacing3x">
                Mobile number: <SkeletonScreen />
              </h1>
            </div>
            <div className="tc-mobility-details-tab-container">
              <div className="tc-mobility-web-service-details__service-information col-sm-6 col-md-4 tc-mobility-web-service-details-border">
                <ServiceDetailsLoadingComponent />
              </div>
              <div className="configuration-settings col-sm-6 col-md-8 tc-mobility-web-service-config-border">
                <Tabs>
                  <div className="container">
                    <TabList className="tc-mobility-tab-padding tc-mobility-tab-list">
                      <Tab
                        name={'tbLink'}
                        panelName={'tbContent'}
                        id={CONSTANTS.SERVICE_USAGE}
                        className="tc-mobility-tab-width"
                        active={activeTab === CONSTANTS.SERVICE_USAGE}
                      >
                        Usage
                      </Tab>
                      <Tab
                        name={'tbLink'}
                        panelName={'tbContent'}
                        id={CONSTANTS.SERVICE_CONFIG}
                        active={activeTab === CONSTANTS.SERVICE_CONFIG}
                        className="tc-mobility-tab-width"
                      >
                        Settings
                      </Tab>
                    </TabList>
                  </div>

                  <TabPanels>
                    <TabPanel
                      name={'tbContent'}
                      id={CONSTANTS.SERVICE_USAGE}
                      active={activeTab === CONSTANTS.SERVICE_USAGE}
                      className="tc-mobility-tab-padding mobility-service-usage-tab"
                    >
                      <UsageLazyLoadingComponent />
                    </TabPanel>
                    <TabPanel
                      name={'tbContent'}
                      id={CONSTANTS.SERVICE_CONFIG}
                      active={activeTab === CONSTANTS.SERVICE_CONFIG}
                      className="tc-mobility-tab-padding mobility-service-usage-tab"
                    >
                      <div className="tc-mobility-general-info-block hidden-xs">
                        <div className="tc-mobility-web-service-details__header">
                          <h3 className="tc-mobility-web-service-details-heading">
                            {headerName.configurationSettings}
                          </h3>
                        </div>
                        <div className="tc-mobility-web-service-details__item-block">
                          {renderGroupSingleItem('Your service reference')}
                          {renderGroupSingleItem('Directory listing')}
                          {renderGroupSingleItem('International Roaming')}
                          <hr />
                          {renderGroupItem('Add-ons')}
                          <hr />
                          {renderGroupItem('Call settings')}
                          <hr />
                          {renderGroupItem('Messaging')}
                          <hr />
                          {renderGroupItem('Data')}
                          <hr />
                          {renderGroupItem('SIM')}
                          <hr />
                          {renderGroupItem('Device ID')}
                        </div>
                      </div>
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </MDUMPageWrapper>
    </NPErrorBoundary>
  )
}
